import { render, staticRenderFns } from "./ServicoModal.vue?vue&type=template&id=7cef613e&scoped=true&"
import script from "./ServicoModal.vue?vue&type=script&lang=js&"
export * from "./ServicoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cef613e",
  null
  
)

export default component.exports